import React, { useEffect, useState } from "react";
import { Box, Chip, IconButton, Stack } from "@mui/material";
import { OpenInNew, Close, UnfoldLess, UnfoldMore } from "@mui/icons-material";

const WindowOpenClose1Widget = ({ widget, onValueUpdate }) => {
  const [status, setStatus] = useState(null);
  const [widgetData, setWidgetData] = useState(null);

  useEffect(() => {
    if (!widget) return;
    setWidgetData(widget);

    if (widget.items?.$w1) {
      const currentValue = widget.items.$w1.value;
      setStatus(
        currentValue === "" || currentValue === null ? "unknown" : currentValue
      );
    }
  }, [widget]);

  const getStatusText = () => {
    if (!status) return "unknown";
    return status;
  };

  const getChipColor = () => {
    switch (status) {
      case "open":
      case "closed":
      case "partially open":
      case "opening":
      case "closing":
        return "secondary";
      default:
        return "default";
    }
  };

  const handleCommand = (command) => {
    if (!widgetData) return;

    const updatedWidget = {
      ...widgetData.items.$w2,
      value: command,
    };
    onValueUpdate(updatedWidget);
  };

  return (
    <Stack
      direction="column"
      spacing={1}
      sx={{
        width: "100%",
        height: "100%",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <Chip
        label={getStatusText()}
        color={getChipColor()}
        variant="contained"
        sx={{
          minWidth: 120,
          fontWeight: 500,
          fontSize: "0.875rem",
          textTransform: "capitalize",
        }}
      />

      <Box
        sx={{
          display: "flex",
          gap: 1,
          mt: 1,
        }}
      >
        <IconButton
          onClick={() => handleCommand("open")}
          color="text.primary"
          sx={{
            backgroundColor: "background.default",
          }}
        >
          <UnfoldMore sx={{ transform: "rotate(90deg)" }} />
        </IconButton>
        <IconButton
          onClick={() => handleCommand("close")}
          color="text.primary"
          sx={{
            backgroundColor: "background.default",
          }}
        >
          <UnfoldLess sx={{ transform: "rotate(90deg)" }} />
        </IconButton>
      </Box>
    </Stack>
  );
};

export default WindowOpenClose1Widget;
